import BreadCrumb from "common/breadcrumb";
import React from "react";
import DefaultSelect from "./default-select";
import DefaultGroupSearch from "./default-group-search";
import OptionsMultipleRemove from "./options-multiple-remove";
import OptionLimitPasting from "./option-limit-pasting";

const FormSelect = () => {
    return (
        <React.Fragment>
            <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
                <BreadCrumb title="Form Select" pageTitle="Forms" />

                <DefaultSelect />

                <h5 className="mb-5 underline">Choices</h5>

                <div className="grid grid-cols-1 gap-x-5 md:grid-cols-2 xl:grid-cols-3">
                    <DefaultGroupSearch />
                    <OptionsMultipleRemove />
                    <OptionLimitPasting />
                </div>
            </div>
        </React.Fragment>
    );
}

export default FormSelect;